import Layout from './layout/reducers';
import GlobalSearch from './GlobalSearch/reducers';

const reducers = {
    Layout,
    GlobalSearch,
};

export default reducers;
